(function() {
	'use strict';

	angular.module('quantixApp').controller('UserAlertSettingsController',
			UserAlertSettingsController);

	UserAlertSettingsController.$inject = [ 'GenericService',
			'CompanyIndAlertService', '$scope', '$window', '$uibModal',
			'AlertService', 'baseRequest', '$timeout','$http' ];

	function UserAlertSettingsController(GenericService,
			CompanyIndAlertService, $scope, $window, $uibModal, AlertService,
			baseRequest, $timeout,$http) {
		$scope.currentbstId = 1;
		var vm = this;
		$scope.userGeneralAlertSetting = {};
		$scope.companyLevelAlertList = [];
		$scope.companyLevelRemoveAlertSelectedList = [];
		$scope.industryLevelAlertList = [];
		$scope.industryLevelRemoveAlertSelectedList = [];
		$scope.portfolioLevelAlertList = [];
		$scope.portfolioLevelRemoveAlertSelectedList = [];
		$scope.companyLevelAlertGrid = '';
		$scope.portfolioLevelAlertGrid = '';
		$scope.industryLevelAlertGrid = '';

		$scope.flagRemoveSelected = true;
		$scope.flagRemoveSelectedPortfolioLevel = true;
		$scope.flagRemoveSelectedIndustry = true;
		$scope.error = false;

		$scope.searchCompanyObj = {
			searchCompany : null
		};

		$scope.searchPortFolioObj = {
			searchPortFolio : null
		};

		$scope.searchIndustryObj = {
			searchIndustries : null
		};
		$scope.currentbstId = 1;
		$scope.setTabSetData = function(tabsetId) {
			$scope.currentbstId = tabsetId;
		}

		$('.toptabsec ul li a').click(function() {
			$('.toptabsec ul li a').removeClass("active");
			$(this).addClass("active");
		});
		$scope.removeSelectAlert = function(alertFlag) {
			if ($scope.currentbstId == 1) {
				$scope.removeSelectCompAlert(alertFlag);
			} else if ($scope.currentbstId == 2) {
				$scope.removeSelectIndustryAlert(alertFlag);
			} else if ($scope.currentbstId == 3) {
				$scope.removeSelectPortfolioAlert(alertFlag);
			}
		}

		$scope.getUserGeneralAlertSettingDetail = function() {
			CompanyIndAlertService
					.getUserGeneralAlertSettingDetailList()
					.then(
							function(data) {
								if (data.length != 0) {

									$scope.userGeneralAlertSetting = data[0];

									$scope.companyLevelAlertList = data[0].companyLevelAlertList;
									$scope.industryLevelAlertList = data[0].industryLevelAlertList;
									$scope.portfolioLevelAlertList = data[0].portfolioLevelAlertList;

									// For company
									$scope.companyLevelAlertGridData = {
										dataProvider : $scope.companyLevelAlertList,
										delegate : $scope
									}

									// For industry
									$scope.industryLevelAlertGridData = {
										dataProvider : $scope.industryLevelAlertList,
										delegate : $scope
									}
									// For PortFolio
									$scope.portfolioLevelAlertGridData = {
										dataProvider : $scope.portfolioLevelAlertList,
										delegate : $scope

									}

								}
							},
							function(errordata) {

								vm.entityResponse = errordata.data;
								$scope.errorMessage = vm.entityResponse.message;
								$scope.error = true;
								$timeout(function() {

									$scope.error = false;
									$scope.errorMessage = "";

								}, 2000);

							});

		}

		$scope.companyLevelAlertGridCompletion = function(event) {

			$scope.companyLevelAlertGrid = event.target;

			$scope.companyLevelAlertGrid.setPreservePager(true);
			$scope.companyLevelAlertGrid
					.setDataProvider($scope.companyLevelAlertList);
			if ($scope.companyLevelAlertList.length > 0) {
				$scope.companyLevelAlertGrid
						.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfCompanies);
			} else {
				$scope.companyLevelAlertGrid.setTotalRecords(0);
			}
			$scope.companyLevelAlertGrid.validateNow();

		};

		$scope.industryLevelAlertGridCompletion = function(event) {
			$scope.industryLevelAlertGrid = event.target;
			$scope.industryLevelAlertGrid.setPreservePager(true);
			$scope.industryLevelAlertGrid
					.setDataProvider($scope.industryLevelAlertList);
			if ($scope.industryLevelAlertList.length > 0) {
				$scope.industryLevelAlertGrid
						.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfIndustries);
			} else {
				$scope.industryLevelAlertGrid.setTotalRecords(0);
			}

			$scope.industryLevelAlertGrid.validateNow();
		};

		$scope.portfolioLevelAlertGridCompletion = function(event) {
			$scope.portfolioLevelAlertGrid = event.target;
			$scope.portfolioLevelAlertGrid.setPreservePager(true);
			$scope.portfolioLevelAlertGrid
					.setDataProvider($scope.portfolioLevelAlertList);
			if ($scope.portfolioLevelAlertList.length > 0) {
				$scope.portfolioLevelAlertGrid
						.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfPortFolioes);
			} else {
				$scope.portfolioLevelAlertGrid.setTotalRecords(0);
			}

			$scope.portfolioLevelAlertGrid.validateNow();
		}

		$scope.onCheckCompaniesSelectedAlerts = function(evt) {

			var grid = evt.target;
			var keys = grid.getSelectedKeys();
			$scope.companyLevelRemoveAlertSelectedList = keys;

		}

		$scope.removeAlertForCompany = function(event) {
			var html = ' <span class="delete" onClick= "removeCompany(this)"><i class="fa fa-bell-slash fa-2x red padding-3"  title="remove" ></i> </span> ';
			return html;
		};

		$window.removeCompany = function(item) {

			var data = item.parentNode.component.data;
			data.isIndustryLevel = "N";
			data.isPortfolioLevel = "N";
			data.isCompanyLevel = "Y";
			$scope.setOrResetAlertForCompany(item.parentNode.component.data);

		}

		$scope.setOrResetAlertForCompany = function(data) {

			$scope.companyData = {
				companyCode : data.companyCode,
				industryId : data.industryId,
				portfolioId : data.portfolioId,
				isIndustryLevel : data.isIndustryLevel,
				isPortfolioLevel : data.isPortfolioLevel,
				isCompanyLevel : data.isCompanyLevel

			};
			var alertName = "";
			if ($scope.companyData.isCompanyLevel == 'Y') {
				alertName = data.companyName;
			} else if ($scope.companyData.isIndustryLevel == 'Y') {
				alertName = data.industryName;
			} else if ($scope.companyData.isPortfolioLevel == 'Y') {
				alertName = data.portfolioName;
			}

			$scope.removeStatus = false;

			$uibModal
					.open({
						templateUrl : 'app/alert components/remove alert/removeAlert-dialog.html',
						controller : 'RemoveAlertDialogController',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							alertNameFor : function() {
								return alertName;
							},
							companyData : function() {
								return $scope.companyData;
							},
							controllerModule : function() {
								return 'UserAlertSettingsController';
							},
							selectedForAll : function() {
								return 'NA';
							},

							selectedForAlertList : function() {
								return [];
							},
							searchedText : function() {
								return "";
							},
							parentAccess : function() {
								return $scope;
							}
						}
					}).closed
					.then(function() {
						if ($scope.removeStatus) {
							if ($scope.companyData.isIndustryLevel == 'Y') {

								if ($scope.industryLevelAlertList.indexOf(data) > -1) {
									$scope.industryLevelAlertList.splice(
											$scope.industryLevelAlertList
													.indexOf(data), 1);
								}
								$scope.flagRemoveSelectedIndustry = false;

								$scope.industryLevelAlertGridData = {
									dataProvider : $scope.industryLevelAlertList,
									delegate : $scope
								}

								$scope.industryLevelAlertGridCompletion = function(
										event) {
									$scope.industryLevelAlertGrid = event.target;
									$scope.industryLevelAlertGrid.validateNow();
								};

								$scope.industryLevelAlertGrid
										.setDataProvider($scope.industryLevelAlertList);
								if ($scope.industryLevelAlertList.length > 0) {
									$scope.industryLevelAlertGrid
											.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfIndustries - 1);
								} else {
									$scope.industryLevelAlertGrid
											.setTotalRecords(0);
								}
								$scope.industryLevelAlertGrid.rebuild();

								$scope.industryLevelAlertGrid.validateNow();

								$timeout(function() {
									$scope.industryLevelAlertGrid
											.setPageIndex(pageIndex);
									$scope.industryLevelAlertGrid
											.setSelectedKeys([], false);
								}, 100);
							} else if ($scope.companyData.isCompanyLevel == 'Y') {

								$scope.flagRemoveSelected = false;

								if ($scope.companyLevelAlertList.indexOf(data) > -1) {
									$scope.companyLevelAlertList.splice(
											$scope.companyLevelAlertList
													.indexOf(data), 1);
								}

								$scope.companyLevelAlertGridData = {
									dataProvider : $scope.companyLevelAlertList,
									delegate : $scope
								}

								$scope.companyLevelAlertGrid
										.setDataProvider($scope.companyLevelAlertList);
								if ($scope.companyLevelAlertList.length > 0) {
									$scope.companyLevelAlertGrid
											.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfCompanies - 1);
								} else {
									$scope.companyLevelAlertGrid
											.setTotalRecords(0);
								}

								$scope.companyLevelAlertGrid.rebuild();
								$scope.companyLevelAlertGrid.validateNow();
								$timeout(function() {
									$scope.companyLevelAlertGrid
											.setPageIndex(pageIndex);
									$scope.companyLevelAlertGrid
											.setSelectedKeys([], false);
								}, 200);

							} else if ($scope.companyData.isPortfolioLevel == 'Y') {

								if ($scope.portfolioLevelAlertList
										.indexOf(data) > -1) {
									$scope.portfolioLevelAlertList.splice(
											$scope.portfolioLevelAlertList
													.indexOf(data), 1);
								}
								$scope.flagRemoveSelectedPortfolioLevel = false;

								$scope.portfolioLevelAlertGridData = {
									dataProvider : $scope.portfolioLevelAlertList,
									delegate : $scope

								}

								$scope.portfolioLevelAlertGrid
										.setDataProvider($scope.portfolioLevelAlertList);
								if ($scope.portfolioLevelAlertList.length > 0) {
									$scope.portfolioLevelAlertGrid
											.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfPortFolioes - 1);
								} else {
									$scope.portfolioLevelAlertGrid
											.setTotalRecords(0);
								}
								$scope.portfolioLevelAlertGrid.rebuild();

								$scope.portfolioLevelAlertGrid.validateNow();

								$timeout(
										function() {
											$scope.portfolioLevelAlertGrid
													.setPageIndex(pageIndexPortfolioLevel);
											$scope.portfolioLevelAlertGrid
													.setSelectedKeys([], false);
										}, 100);

							}

						}

					});

		}

		$scope.removeSelectCompAlert = function(selectedForAll) {

			for ( var key in $scope.filterPageSortChangeCompanyLevelMap) {
				if ($scope.filterPageSortChangeCompanyLevelMap
						.hasOwnProperty(key)
						&& key != pageIndex
						&& $scope.filterPageSortChangeCompanyLevelMap[key].length != 0) {
					var concatList = $scope.companyLevelRemoveAlertSelectedList
							.concat($scope.filterPageSortChangeCompanyLevelMap[key]);
					$scope.companyLevelRemoveAlertSelectedList = concatList
							.filter(function(item, pos) {
								return concatList.indexOf(item) == pos
							});

				}

			}

			if ($scope.companyLevelAlertList.length == 0
					&& $scope.companyLevelRemoveAlertSelectedList.length == 0) {
				// alert("Sorry ! No matching records found");
			} else if (selectedForAll == 'N'
					&& $scope.companyLevelAlertList.length > 0
					&& $scope.companyLevelRemoveAlertSelectedList.length == 0) {
				alert("Please select atleast one company");
			} else {

				$scope.removeStatusForAllorSelected = false;
				$scope.companyData = {
					companyCode : 'TELCO',
					isIndustryLevel : 'N',
					isPortfolioLevel : 'N',
					isCompanyLevel : 'Y'

				};

				if (selectedForAll == 'Y') {
					$scope.alertName = 'All filtered records';
				} else {
					$scope.alertName = 'Selected Company';

				}
				$scope.alertNameSelectedOrAll = "";
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlertForSelectedOrAll-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return $scope.alertName;
								},
								companyData : function() {
									return $scope.companyData;
								},
								selectedForAll : function() {
									return selectedForAll;
								},

								selectedForAlertList : function() {
									return $scope.companyLevelRemoveAlertSelectedList;
								},
								searchedText : function() {
									return $scope.searchCompanyObj.searchCompany;
								},
								controllerModule : function() {
									return 'UserAlertSettingsController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {

					if ($scope.removeStatusForAllorSelected) {
						$scope.getUserGeneralCompanyLevelAlertsList();
					}

				});

			}
		}

		$scope.getUserGeneralCompanyLevelAlertsList = function() {
			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchCompanyObj.searchCompany,
				typeOfAlertLevel : 'COMPANY_LEVEL'
			};

			$scope.getUserGeneralCompanyLevelAlertsFilterList(filter);

		}

		$scope.filterOnCompaniesLevelAlertSearch = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchCompanyObj.searchCompany,
				typeOfAlertLevel : 'COMPANY_LEVEL'
			};

			$scope.getUserGeneralCompanyLevelAlertsFilterList(filter);

		}
		$scope.filterOnCompaniesLevelAlertReset = function(myCompanyAlertForm) {
			$scope.searchCompanyObj.searchCompany = null;
			myCompanyAlertForm.$setPristine();
			$scope.getUserGeneralCompanyLevelAlertsList();
			$timeout(function() {
				$scope.companyLevelAlertGrid.setPageIndex(0);
			}, 100);
			$scope.filterPageSortChangeCompanyLevelMap = {};

		}

		$scope.changeInNotificationAlertOn = function(alertOn) {

			if ($scope.userGeneralAlertSetting.isPlatform != ''
					&& $scope.userGeneralAlertSetting.isEmail != '') {
				
				if($scope.userGeneralAlertSetting.isEmail == 'N'){
					$scope.userGeneralAlertSetting.consolidatedMailSelect = "N";
					$scope.userGeneralAlertSetting.consolidatedMailType = null;
					$scope.updateConsolidatedEmailSetting(
							$scope.userGeneralAlertSetting.consolidatedMailSelect,
							$scope.userGeneralAlertSetting.consolidatedMailType);
				}
				
				$scope.updateNotificationDetails(
						$scope.userGeneralAlertSetting.isPlatform,
						$scope.userGeneralAlertSetting.isEmail);
			}
		}

		$scope.updateNotificationDetails = function(isPlatform, isEmail) {

			CompanyIndAlertService
					.updateNotificationToBeAlertOn(isPlatform, isEmail)
					.then(
							function(result) {

							},
							function(errordata) {
								AlertService
										.error("Error while updating notification setting triggred on ");
							});

		}
		
		$scope.consolidatedMailCheckFuntion = function(){
			if($scope.userGeneralAlertSetting.consolidatedMailSelect == "N"){
				$scope.userGeneralAlertSetting.consolidatedMailType = null;
			
			$scope.updateConsolidatedEmailSetting(
					$scope.userGeneralAlertSetting.consolidatedMailSelect,
					$scope.userGeneralAlertSetting.consolidatedMailType);
			}
		}
		
		$scope.consolidatedMailSelectFuntion = function(){
			$scope.updateConsolidatedEmailSetting(
					$scope.userGeneralAlertSetting.consolidatedMailSelect,
					$scope.userGeneralAlertSetting.consolidatedMailType);
		}
		
		$scope.updateConsolidatedEmailSetting = function(consolidatedMailSelect,consolidatedMailType){
			CompanyIndAlertService
			.updateConsolidatedEmailSetting(consolidatedMailSelect, consolidatedMailType)
			.then(
					function(result) {

					},
					function(errordata) {
						AlertService
								.error("Error while updating consolidated mail setting ");
					});	
		}
		
		$scope.onCheckIndustriesSelectedAlerts = function(evt) {
			var grid = evt.target;
			var keys = grid.getSelectedKeys();
			$scope.industryLevelRemoveAlertSelectedList = keys;

		}

		$scope.removeAlertForIndustry = function(event) {
			var html = ' <span class="delete" onClick= "removeIndustry(this)"><i   class="fa fa-bell-slash fa-2x red padding-3"  title="remove" ></i> </span> ';
			return html;
		};

		$window.removeIndustry = function(item) {

			var data = item.parentNode.component.data;
			data.isIndustryLevel = "Y";
			data.isPortfolioLevel = "N";
			data.isCompanyLevel = "N";
			$scope.setOrResetAlertForCompany(data);

		}
		// For Applying filter on industry
		$scope.filterOnIndustriesLevelAlertSearch = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchIndustryObj.searchIndustries,
				typeOfAlertLevel : 'INDUSTRY_LEVEL'
			};
			$scope.getUserGeneralIndustryLevelAlertsFilterList(filter);
		}
		$scope.filterOnIndustryLevelAlertReset = function(myIndustryAlertForm) {
			$scope.searchIndustryObj.searchIndustries = null;
			myIndustryAlertForm.$setPristine();
			$scope.getUserGeneralIndustryLevelAlertsList();
			$timeout(function() {
				$scope.industryLevelAlertGrid.setPageIndex(0);
			}, 100);
		}

		// For getting Industry level alert list
		$scope.getUserGeneralIndustryLevelAlertsList = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchIndustryObj.searchIndustries,
				typeOfAlertLevel : 'INDUSTRY_LEVEL'
			};
			$scope.getUserGeneralIndustryLevelAlertsFilterList(filter);
		}

		$scope.removeSelectIndustryAlert = function(selectedForAll) {

			for ( var key in $scope.filterPageSortChangeIndustryLevelMap) {
				if ($scope.filterPageSortChangeIndustryLevelMap
						.hasOwnProperty(key)
						&& key != pageIndexIndustry
						&& $scope.filterPageSortChangeIndustryLevelMap[key].length != 0) {
					var concatList = $scope.industryLevelRemoveAlertSelectedList
							.concat($scope.filterPageSortChangeIndustryLevelMap[key]);
					$scope.industryLevelRemoveAlertSelectedList = concatList
							.filter(function(item, pos) {
								return concatList.indexOf(item) == pos
							});

				}

			}

			if ($scope.industryLevelAlertList.length == 0
					&& $scope.industryLevelRemoveAlertSelectedList.length == 0) {
				alert("Sorry ! No matching records found");
			} else if (selectedForAll == 'N'
					&& $scope.industryLevelAlertList.length > 0
					&& $scope.industryLevelRemoveAlertSelectedList.length == 0) {
				alert("Please select atleast one Industry");
			} else {

				$scope.removeStatusForAllorSelected = false;
				var industryData = {

					isIndustryLevel : 'Y',
					isPortfolioLevel : 'N',
					isCompanyLevel : 'N'

				};
				if (selectedForAll == 'Y') {
					$scope.alertName = 'All filtered records';
				} else {
					$scope.alertName = 'Selected Industry';
				}
				$scope.alertNameSelectedOrAll = "";
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlertForSelectedOrAll-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return $scope.alertName;
								},
								companyData : function() {
									return industryData;
								},
								selectedForAll : function() {
									return selectedForAll;
								},

								selectedForAlertList : function() {
									return $scope.industryLevelRemoveAlertSelectedList;
								},
								searchedText : function() {
									return $scope.searchIndustryObj.searchIndustries;
								},
								controllerModule : function() {
									return 'UserAlertSettingsController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {

					if ($scope.removeStatusForAllorSelected) {
						$scope.getUserGeneralIndustryLevelAlertsList();
					}

				});
			}
		}

		// For Applying filter on portFolio
		$scope.filterOnPortFoliosLevelAlertSearch = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchPortFolioObj.searchPortFolio,
				typeOfAlertLevel : 'PORTFOLIO_LEVEL'
			};

			$scope.getUserGeneralPortFolioLevelAlertsFilterList(filter);

		}

		$scope.filterOnPortfolioLevelAlertReset = function(myPortfolioAlertForm) {
			$scope.searchPortFolioObj.searchPortFolio = null;
			myPortfolioAlertForm.$setPristine();

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchPortFolioObj.searchPortFolio,
				typeOfAlertLevel : 'PORTFOLIO_LEVEL'
			};
			$scope.getUserGeneralPortFolioLevelAlertsFilterList(filter);
			$timeout(function() {
				$scope.portfolioLevelAlertGrid.setPageIndex(0);
			}, 100);
		}

		// For getting Portfolio level alert list
		$scope.getUserGeneralPortfolioLevelAlertsList = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 30,
				searchText : $scope.searchPortFolioObj.searchPortFolio,
				typeOfAlertLevel : 'PORTFOLIO_LEVEL'
			};

			$scope.getUserGeneralPortFolioLevelAlertsFilterList(filter);

		}

		$scope.onCheckPortfoliosSelectedAlerts = function(evt) {

			var grid = evt.target;
			var keys = grid.getSelectedKeys();
			$scope.portfolioLevelRemoveAlertSelectedList = keys;

		}
		$scope.removeAlertForPortfolio = function(event) {
			var html = ' <span class="delete" onClick= "removePortfolio(this)"><i class="fa fa-bell-slash fa-2x red padding-3"  title="remove" ></i> </span> ';
			return html;
		};

		$window.removePortfolio = function(item) {

			var data = item.parentNode.component.data;
			data.isIndustryLevel = "N";
			data.isPortfolioLevel = "Y";
			data.isCompanyLevel = "N";
			$scope.setOrResetAlertForCompany(data);

		}

		$scope.removeSelectPortfolioAlert = function(selectedForAll) {

			for ( var key in $scope.filterPageSortChangePortfolioLevelMap) {
				if ($scope.filterPageSortChangePortfolioLevelMap
						.hasOwnProperty(key)
						&& key != pageIndexPortfolioLevel
						&& $scope.filterPageSortChangePortfolioLevelMap[key].length != 0) {
					var concatList = $scope.portfolioLevelRemoveAlertSelectedList
							.concat($scope.filterPageSortChangePortfolioLevelMap[key]);
					$scope.portfolioLevelRemoveAlertSelectedList = concatList
							.filter(function(item, pos) {
								return concatList.indexOf(item) == pos
							});

				}

			}

			if ($scope.portfolioLevelAlertList.length == 0
					&& $scope.portfolioLevelRemoveAlertSelectedList.length == 0) {
				alert("Sorry ! No matching records found");
			} else if (selectedForAll == 'N'
					&& $scope.portfolioLevelAlertList.length > 0
					&& $scope.portfolioLevelRemoveAlertSelectedList.length == 0) {
				alert("Please select atleast one Portfolio");
			} else {

				$scope.removeStatusForAllorSelected = false;
				var portfolioData = {
					isIndustryLevel : 'N',
					isPortfolioLevel : 'Y',
					isCompanyLevel : 'N'

				};
				var alertName = "";
				if (selectedForAll == 'Y') {
					alertName = 'All filtered records';
				} else {
					alertName = 'Selected Portfolio';
				}
				$scope.alertNameSelectedOrAll = "";
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlertForSelectedOrAll-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return alertName;
								},
								companyData : function() {
									return portfolioData;
								},
								selectedForAll : function() {
									return selectedForAll;
								},

								selectedForAlertList : function() {
									return $scope.portfolioLevelRemoveAlertSelectedList;
								},
								searchedText : function() {
									return $scope.searchPortFolioObj.searchPortFolio;
								},
								controllerModule : function() {
									return 'UserAlertSettingsController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {

					if ($scope.removeStatusForAllorSelected) {
						$scope.getUserGeneralPortfolioLevelAlertsList();
					}

				});
			}
		}

		$scope.filterPageSortChangeCompanyLevelMap = {};
		var pageIndex = 0;
		$scope.filterPageSortChangeHandlerCompanyLevel = function(evt1) {

			if ($scope.flagRemoveSelected) {
				var grid = evt1.target;
				var selectedKeys = [];

				if ($scope.filterPageSortChangeCompanyLevelMap[evt1.filter.pageIndex] != undefined
						&& $scope.filterPageSortChangeCompanyLevelMap[evt1.filter.pageIndex].length != 0) {
					selectedKeys = $scope.filterPageSortChangeCompanyLevelMap[evt1.filter.pageIndex];

				}

				$scope.filterPageSortChangeCompanyLevelMap[pageIndex] = grid
						.getSelectedKeys();
				var filter = {};

				pageIndex = evt1.filter.pageIndex;
				var filter = {
					pageNumber : evt1.filter.pageIndex + 1 || 1,
					pageSize : evt1.filter.pageSize || 30,
					searchText : $scope.searchCompanyObj.searchCompany,
					typeOfAlertLevel : 'COMPANY_LEVEL'
				};

				baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
						filter)
						.then(
								function(response) {
									grid.setPreservePager(true);
									grid
											.setDataProvider(response.data.typeOfAlertLevelList);
									$scope.companyLevelAlertList = response.data.typeOfAlertLevelList;
									if (response.data.typeOfAlertLevelList.length > 0) {
										$scope.userGeneralAlertSetting.totalCountOfCompanies = response.data.totalCountOfALertLevelList;
										grid
												.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfCompanies);
									} else {
										grid.setTotalRecords(0);
									}
									grid.validateNow();

									$timeout(function() {
										grid.setSelectedKeys(selectedKeys,
												false);
									}, 500);

								},
								function(errordata) {

									vm.entityResponse = errordata.data;
									$scope.errorMessage = vm.entityResponse.message;
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);

								});

			} else {
				$scope.flagRemoveSelected = true;
			}

		}
		// Page Filter For Industry

		$scope.filterPageSortChangeIndustryLevelMap = {};
		var pageIndexIndustry = 0;

		$scope.filterPageSortChangeHandlerIndustryLevel = function(evt1) {
			if ($scope.flagRemoveSelectedIndustry) {

				var grid = evt1.target;
				var selectedKeys = [];

				if ($scope.filterPageSortChangeIndustryLevelMap[evt1.filter.pageIndex] != undefined
						&& $scope.filterPageSortChangeIndustryLevelMap[evt1.filter.pageIndex].length != 0) {
					selectedKeys = $scope.filterPageSortChangeIndustryLevelMap[evt1.filter.pageIndex];

				}

				$scope.filterPageSortChangeIndustryLevelMap[pageIndexIndustry] = grid
						.getSelectedKeys();
				if ($scope.flagRemoveSelectedIndustry) {
					pageIndexIndustry = evt1.filter.pageIndex;
					$scope.flagRemoveSelectedIndustry = true;
				}

				var filter = {
					pageNumber : evt1.filter.pageIndex + 1 || 1,
					pageSize : evt1.filter.pageSize || 30,
					searchText : $scope.searchIndusrtyObj.searchIndustry,
					typeOfAlertLevel : 'INDUSTRY_LEVEL'
				};
				baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
						filter)
						.then(
								function(response) {
									grid.setPreservePager(true);
									grid
											.setDataProvider(response.data.typeOfAlertLevelList);
									$scope.industryLevelAlertList = response.data.typeOfAlertLevelList;
									if (response.data.typeOfAlertLevelList.length > 0) {
										$scope.userGeneralAlertSetting.totalCountOfIndustries = response.data.totalCountOfALertLevelList;
										grid
												.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfIndustries);
									} else {
										grid.setTotalRecords(0);
									}
									grid.validateNow();

									$timeout(function() {
										grid.setSelectedKeys(selectedKeys,
												false);
									}, 100);

								},
								function(errordata) {

									vm.entityResponse = errordata.data;
									$scope.errorMessage = vm.entityResponse.message;
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);

								});

			} else {
				$scope.flagRemoveSelectedIndustry = true;
			}

		}

		//	

		$scope.filterPageSortChangePortfolioLevelMap = {};
		var pageIndexPortfolioLevel = 0;

		$scope.filterPageSortChangeHandlerPortfolioLevel = function(evt1) {
			if ($scope.flagRemoveSelectedPortfolioLevel) {

				var grid = evt1.target;
				var selectedKeys = [];

				if ($scope.filterPageSortChangePortfolioLevelMap[evt1.filter.pageIndex] != undefined
						&& $scope.filterPageSortChangePortfolioLevelMap[evt1.filter.pageIndex].length != 0) {
					selectedKeys = $scope.filterPageSortChangePortfolioLevelMap[evt1.filter.pageIndex];

				}

				$scope.filterPageSortChangePortfolioLevelMap[pageIndexPortfolioLevel] = grid
						.getSelectedKeys();
				pageIndexPortfolioLevel = evt1.filter.pageIndex;
				$scope.flagRemoveSelectedPortfolioLevel = true;

				var filter = {
					pageNumber : evt1.filter.pageIndex + 1 || 1,
					pageSize : evt1.filter.pageSize || 30,
					searchText : $scope.searchPortFolioObj.searchPortFolio,
					typeOfAlertLevel : 'PORTFOLIO_LEVEL'
				};

				baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
						filter)
						.then(
								function(response) {

									grid.setPreservePager(true);
									$scope.portfolioLevelAlertList = response.data.typeOfAlertLevelList;
									grid
											.setDataProvider(response.data.typeOfAlertLevelList);
									if (response.data.typeOfAlertLevelList.length > 0) {
										$scope.userGeneralAlertSetting.totalCountOfPortFolioes = response.data.totalCountOfALertLevelList;
										grid
												.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfPortFolioes);
									} else {
										grid.setTotalRecords(0);
									}
									grid.validateNow();

									$timeout(function() {
										grid.setSelectedKeys(selectedKeys,
												false);
									}, 100);

								},
								function(errordata) {

									vm.entityResponse = errordata.data;
									$scope.errorMessage = vm.entityResponse.message;
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);

								});

			} else {
				$scope.flagRemoveSelectedPortfolioLevel = false;
			}
		}

		$scope.getUserGeneralCompanyLevelAlertsFilterList = function(filter) {

			baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
					filter)
					.then(
							function(response) {
								$timeout(
										function() {

											$scope.companyLevelAlertList = response.data.typeOfAlertLevelList;

											$scope.companyLevelAlertGridData = {
												dataProvider : $scope.companyLevelAlertList,
												delegate : $scope
											}

											$scope.companyLevelAlertGrid
													.setPreservePager(true);
											$scope.companyLevelAlertGrid
													.setDataProvider($scope.companyLevelAlertList);
											if ($scope.companyLevelAlertList.length > 0) {
												$scope.userGeneralAlertSetting.totalCountOfCompanies = response.data.totalCountOfALertLevelList;
												$scope.companyLevelAlertGrid
														.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfCompanies);
											} else {
												$scope.companyLevelAlertGrid
														.setTotalRecords(0);
											}
											$scope.companyLevelAlertGrid
													.rebuild();
											$scope.companyLevelAlertGrid
													.validateNow();
											$timeout(function() {
												$scope.companyLevelAlertGrid
														.setSelectedKeys([],
																false);
											}, 100);
											$scope.filterPageSortChangeCompanyLevelMap = {};
										}, 100);

							},
							function(errordata) {

								vm.entityResponse = errordata.data;
								$scope.errorMessage = vm.entityResponse.message;
								$scope.error = true;
								$timeout(function() {

									$scope.error = false;
									$scope.errorMessage = "";

								}, 2000);

							});

		}

		$scope.getUserGeneralPortFolioLevelAlertsFilterList = function(filter) {

			baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
					filter)
					.then(
							function(response) {

								$timeout(
										function() {
											$scope.portfolioLevelAlertList = response.data.typeOfAlertLevelList;
											$scope.portfolioLevelAlertGridData = {
												dataProvider : $scope.portfolioLevelAlertList,
												delegate : $scope

											}

											$scope.portfolioLevelAlertGrid
													.setPreservePager(true);
											$scope.portfolioLevelAlertList = response.data.typeOfAlertLevelList;
											$scope.portfolioLevelAlertGrid
													.setDataProvider(response.data.typeOfAlertLevelList);
											if (response.data.typeOfAlertLevelList.length > 0) {
												$scope.userGeneralAlertSetting.totalCountOfPortFolioes = response.data.totalCountOfALertLevelList;
												$scope.portfolioLevelAlertGrid
														.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfPortFolioes);
											} else {
												$scope.portfolioLevelAlertGrid
														.setTotalRecords(0);
											}
											$scope.portfolioLevelAlertGrid
													.rebuild();
											$scope.portfolioLevelAlertGrid
													.validateNow();
											$timeout(function() {
												$scope.portfolioLevelAlertGrid
														.setSelectedKeys([],
																false);
											}, 100);
											$scope.filterPageSortChangePortfolioLevelMap = {};
										}, 100);

							},
							function(errordata) {

								vm.entityResponse = errordata.data;
								$scope.errorMessage = vm.entityResponse.message;
								$scope.error = true;
								$timeout(function() {

									$scope.error = false;
									$scope.errorMessage = "";

								}, 2000);

							});

		}

		$scope.getUserGeneralIndustryLevelAlertsFilterList = function(filter) {

			baseRequest('api/userSettingAlert/getFilterAlertDetailsList',
					filter)
					.then(
							function(response) {
								$timeout(
										function() {
											$scope.industryLevelAlertList = response.data.typeOfAlertLevelList;
											$scope.industryLevelAlertGridData = {
												dataProvider : $scope.industryLevelAlertList,
												delegate : $scope

											}

											$scope.industryLevelAlertGrid
													.setPreservePager(true);
											$scope.industryLevelAlertList = response.data.typeOfAlertLevelList;
											$scope.industryLevelAlertGrid
													.setDataProvider(response.data.typeOfAlertLevelList);
											if (response.data.typeOfAlertLevelList.length > 0) {
												$scope.userGeneralAlertSetting.totalCountOfIndustries = response.data.totalCountOfALertLevelList;
												$scope.industryLevelAlertGrid
														.setTotalRecords($scope.userGeneralAlertSetting.totalCountOfIndustries);
											} else {
												$scope.industryLevelAlertGrid
														.setTotalRecords(0);
											}
											$scope.industryLevelAlertGrid
													.rebuild();
											$scope.industryLevelAlertGrid
													.validateNow();
											$timeout(function() {
												$scope.industryLevelAlertGrid
														.setSelectedKeys([],
																false);
											}, 100);

											$scope.filterPageSortChangeIndustryLevelMap = {};
										}, 100);

							},
							function(errordata) {

								vm.entityResponse = errordata.data;
								$scope.errorMessage = vm.entityResponse.message;
								$scope.error = true;
								$timeout(function() {

									$scope.error = false;
									$scope.errorMessage = "";

								}, 2000);

							});

		}
		//Export Excel
		
		$scope.getUserAlertExport = function() {
			
			console.log("inside");

			$http({
				url : 'api/userSettingAlert/getUserAlertExportData',
				method : 'POST',
				data : $scope.userTrackerExDataTemp,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {

								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'UsageTracker Report.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'UserAlertExportReport.xlsx'
									})[0].click();

									anchor.remove();

								}

							})

		}
		
		
		
		
		
		
		
		
		
		$scope.getUserGeneralAlertSettingDetail();

	}
})();
